import { CardContainer } from "./CardContainer"
import { CardStat } from "./CardComps"
import LaunchIcon from "@mui/icons-material/Launch"
import { IconButton, Chip } from "@mui/material"
import { Link } from "react-router-dom"
import routes from "../../constants/routes"
import dayjs from "dayjs"
import InsertDriveFileRoundedIcon from "@mui/icons-material/InsertDriveFileRounded";

const NoteCard = ({ data }) => (
  <CardContainer
    disableEditDelete
    SummaryContent={
      <>
        <CardStat label="Note" value={data?.name} />
        <CardStat label="Title" value={data?.title} />
        <CardStat label="Document" value={(<Link to={data?.link}><Chip icon={<InsertDriveFileRoundedIcon />} label={data?.document}/></Link>)} />
        
      </>
    }
    DetailsContent={
      <>
        <CardStat label="Description" value={data?.description} />
        <CardStat label="Status" value={data?.status} />
      </>
    }
  />
)

export default NoteCard
